export const APP_ROUTES = {
  login: '/login',
  myAccess: '/me',
  home: '/',
  people: '/people',
  newPerson: '/people/new',
  person: (id: string) => `/people/${id}`,
  applications: '/applications',
  application: (key: string) => `/applications/${key}`,
} as const;

/** Router state set by Add person so the person page can say the record is new. */
export const NEW_PERSON_STATE_KEY = 'justAdded';
